(function () {
  "use strict";

  var INVALID_CENTS = 1; // 0,01 EUR exprimé en centimes
  var GUARD_DISABLED = "data-lfl-price-guard-disabled";
  var GUARD_HIDDEN = "data-lfl-price-guard-hidden";
  var GUARD_DISPLAY = "data-lfl-price-guard-display";
  var GUARD_LABEL = "data-lfl-price-guard-label";

  function money(cents) {
    if (typeof window.formatMoney === "function") {
      try {
        return window.formatMoney(cents, (window.MinimogSettings || {}).money_format);
      } catch (e) { /* fallback */ }
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function productData(productId) {
    return (window._themeProducts || {})[String(productId)];
  }

  function findVariant(productId, variantId) {
    var pd = productData(productId);
    var list = (pd && pd.variants) || [];
    return list.filter(function (variant) {
      return Number(variant.id) === Number(variantId);
    })[0] || null;
  }

  function variantIsValid(variant) {
    return !!variant && Number(variant.price) > INVALID_CENTS;
  }

  function variantIsAvailable(variant) {
    return !!variant && variant.available !== false;
  }

  function variantIsPurchasable(variant) {
    return variantIsValid(variant) && variantIsAvailable(variant);
  }

  function strings() {
    return window.LFLPriceStrings || {};
  }

  function storeOnlyMessage() {
    return strings().storeOnly ||
      "Cette configuration est disponible en magasin. Contactez nos conseillers.";
  }

  function selectorForProduct(selector, productId) {
    return selector + '[data-product-id="' + String(productId) + '"]';
  }

  function queryProductNode(root, selector, productId) {
    var scopedSelector = selectorForProduct(selector, productId);
    var scope = root && typeof root.querySelector === "function" ? root : document;
    if (scope.matches && scope.matches(scopedSelector)) return scope;
    return scope.querySelector(scopedSelector);
  }

  function productForms(productId, root) {
    var selector = 'form[data-product-id="' + String(productId) + '"]';
    var scope = root && typeof root.querySelectorAll === "function" ? root : document;
    var forms = [];
    if (scope.matches && scope.matches(selector)) forms.push(scope);
    var descendants = scope.querySelectorAll(selector);
    for (var i = 0; i < descendants.length; i++) forms.push(descendants[i]);
    return forms;
  }

  function rememberLabel(label) {
    if (label && !label.hasAttribute(GUARD_LABEL)) {
      label.setAttribute(GUARD_LABEL, label.textContent || "");
    }
  }

  function disableButton(button, label, text) {
    if (!button) return;
    if (!button.disabled && !button.classList.contains("disabled")) {
      button.setAttribute(GUARD_DISABLED, "true");
    }
    button.setAttribute("disabled", "disabled");
    button.classList.add("disabled");
    rememberLabel(label);
    if (label) label.textContent = text;
  }

  function releaseButton(button, label) {
    if (!button || !button.hasAttribute(GUARD_DISABLED)) return;
    button.removeAttribute("disabled");
    button.classList.remove("disabled");
    button.removeAttribute(GUARD_DISABLED);
    if (label && label.hasAttribute(GUARD_LABEL)) {
      label.textContent = label.getAttribute(GUARD_LABEL) ||
        (window.MinimogStrings || {}).addToCart || "Ajouter au panier";
      label.removeAttribute(GUARD_LABEL);
    }
  }

  function hideNode(node) {
    if (!node || node.classList.contains("m:hidden")) return;
    node.classList.add("m:hidden");
    node.setAttribute(GUARD_HIDDEN, "true");
  }

  function releaseHiddenNode(node) {
    if (!node || !node.hasAttribute(GUARD_HIDDEN)) return;
    node.classList.remove("m:hidden");
    node.removeAttribute(GUARD_HIDDEN);
  }

  function hideDisplay(node) {
    if (!node || node.style.display === "none") return;
    node.setAttribute(GUARD_DISPLAY, node.style.display || "");
    node.style.display = "none";
  }

  function releaseDisplay(node) {
    if (!node || !node.hasAttribute(GUARD_DISPLAY)) return;
    node.style.display = node.getAttribute(GUARD_DISPLAY) || "";
    node.removeAttribute(GUARD_DISPLAY);
  }

  function priceBlockFor(productId, root) {
    return queryProductNode(root, ".m-price", productId);
  }

  function setPriceBlock(productId, variant, root) {
    var block = priceBlockFor(productId, root);
    if (!block) return;
    var mode = block.dataset.salesMode;

    if (mode === "magasin_prix_exact") {
      if (variant && variantIsValid(variant)) {
        var text = money(variant.price);
        var exact = block.querySelector(".lfl-store-price--exact");
        if (exact) exact.textContent = text;
        var stickyHost = document.querySelector(
          'sticky-atc[data-product-id="' + String(productId) + '"]',
        );
        var stickyPrice = stickyHost && stickyHost.querySelector("[data-lfl-sticky-price]");
        if (stickyPrice) stickyPrice.textContent = text;
      }
      return;
    }

    if (mode !== "ecommerce") return;

    var valid = variantIsValid(variant);
    var regularWrapper = block.querySelector(".m-price__regular");
    var saleWrapper = block.querySelector(".m-price__sale");
    var onDemand = block.querySelector(".lfl-store-price--on-demand");
    block.classList.toggle("lfl-variant-invalid", !valid);

    if (!valid) {
      if (!onDemand) {
        onDemand = document.createElement("span");
        onDemand.className = "lfl-store-price lfl-store-price--on-demand";
        onDemand.textContent = strings().variantOnDemand ||
          "Tarif sur demande pour cette dimension";
        block.appendChild(onDemand);
      }
      hideDisplay(regularWrapper);
      hideDisplay(saleWrapper);
      return;
    }

    if (onDemand && onDemand.parentNode) onDemand.parentNode.removeChild(onDemand);
    releaseDisplay(regularWrapper);
    releaseDisplay(saleWrapper);
  }

  function setFormsState(productId, variant, root) {
    var pd = productData(productId);
    if (!pd || pd.sales_mode !== "ecommerce") return;
    var valid = variantIsValid(variant);
    var available = variantIsAvailable(variant);
    var forms = productForms(productId, root);

    for (var i = 0; i < forms.length; i++) {
      var add = forms[i].querySelector('[name="add"]');
      var dynamicCheckout = forms[i].querySelector(".m-product-dynamic-checkout");
      var label = add && add.querySelector(".m-add-to-cart--text");

      if (!valid) {
        disableButton(
          add,
          label,
          strings().variantOnDemand || "Tarif sur demande pour cette dimension",
        );
        hideNode(dynamicCheckout);
      } else if (!available) {
        disableButton(
          add,
          label,
          (window.MinimogStrings || {}).soldOut || "Épuisé",
        );
        hideNode(dynamicCheckout);
      } else {
        releaseButton(add, label);
        releaseHiddenNode(dynamicCheckout);
      }
    }
  }

  function setStickyState(productId, variant) {
    var pd = productData(productId);
    if (!pd || pd.sales_mode !== "ecommerce") return;
    var stickyHost = document.querySelector(
      'sticky-atc[data-product-id="' + String(productId) + '"]',
    );
    if (!stickyHost) return;
    var sticky = stickyHost.closest(".m-sticky-addtocart");
    if (!sticky) return;
    var form = sticky.querySelector('form[data-product-id="' + String(productId) + '"]');
    var quote = stickyHost.querySelector("[data-lfl-sticky-quote]");

    if (!variantIsValid(variant)) {
      hideDisplay(form);
      if (quote) {
        if (!quote.hasAttribute(GUARD_DISPLAY)) {
          quote.setAttribute(GUARD_DISPLAY, quote.style.display || "");
        }
        quote.style.display = "";
      }
    } else {
      releaseDisplay(form);
      if (quote && quote.hasAttribute(GUARD_DISPLAY)) {
        quote.style.display = quote.getAttribute(GUARD_DISPLAY) || "";
        quote.removeAttribute(GUARD_DISPLAY);
      }
    }
  }

  function applyProductVariantState(productId, variant, root) {
    var pd = productData(productId);
    if (!pd || !variant) return;
    var mode = pd.sales_mode;
    if (mode === "magasin_a_partir" || mode === "magasin_sur_demande") return;
    setPriceBlock(productId, variant, root);
    setFormsState(productId, variant, root);
    setStickyState(productId, variant);
  }

  function isInvalidPrice(price) {
    var numericPrice = Number(price);
    return Number.isFinite(numericPrice) && numericPrice <= INVALID_CENTS;
  }

  function addId(ids, value) {
    if (value === null || typeof value === "undefined") return;
    var id = String(value).trim();
    if (/^\d+$/.test(id)) ids.push(id);
  }

  function collectObjectIds(value, ids) {
    if (!value) return;
    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) collectObjectIds(value[i], ids);
      return;
    }
    if (typeof value !== "object") return;
    if (Object.prototype.hasOwnProperty.call(value, "id")) addId(ids, value.id);
    if (Object.prototype.hasOwnProperty.call(value, "items")) {
      collectObjectIds(value.items, ids);
    }
  }

  function isVariantIdKey(key) {
    return key === "id" || /^items\[(?:\d*)\]\[id\]$/.test(key);
  }

  function collectEntries(entries, ids) {
    for (var iterator = entries[Symbol.iterator](), step; !(step = iterator.next()).done;) {
      var pair = step.value;
      if (isVariantIdKey(String(pair[0]))) addId(ids, pair[1]);
      if (pair[0] === "items" && typeof pair[1] === "string") {
        try {
          collectObjectIds(JSON.parse(pair[1]), ids);
        } catch (e) { /* valeur inconnue : laisser passer */ }
      }
    }
  }

  // Extrait sans bloquer les formats inconnus. Un tableau vide signifie
  // « aucune variante connue avec certitude ».
  function extractVariantIds(body) {
    var ids = [];
    if (!body) return ids;

    if (typeof FormData !== "undefined" && body instanceof FormData) {
      collectEntries(body.entries(), ids);
      return ids;
    }
    if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
      collectEntries(body.entries(), ids);
      return ids;
    }
    if (typeof body === "object") {
      collectObjectIds(body, ids);
      return ids;
    }
    if (typeof body !== "string") return ids;

    var text = body.trim();
    if (!text) return ids;
    try {
      collectObjectIds(JSON.parse(text), ids);
      return ids;
    } catch (e) { /* essayer le format urlencoded */ }

    try {
      var params = new URLSearchParams(text);
      collectEntries(params.entries(), ids);
    } catch (e) { /* valeur inconnue : laisser passer */ }
    return ids;
  }

  function blockedVariantIds() {
    var blocked = {};
    var globalIds = window.LFLBlockedVariantIds || [];
    for (var g = 0; g < globalIds.length; g++) blocked[String(globalIds[g])] = true;
    var products = window._themeProducts || {};
    var keys = Object.keys(products);
    for (var i = 0; i < keys.length; i++) {
      var ids = products[keys[i]] && products[keys[i]].blocked_variant_ids;
      if (!ids) continue;
      for (var j = 0; j < ids.length; j++) blocked[String(ids[j])] = true;
    }
    return blocked;
  }

  // Bloque les variantes magasin explicitement marquées et les variantes
  // ecommerce dont le prix artificiel est connu.
  function variantKnownInvalid(id) {
    var blocked = blockedVariantIds();
    if (blocked[String(id)]) return true;
    var products = window._themeProducts || {};
    var keys = Object.keys(products);
    for (var i = 0; i < keys.length; i++) {
      var pd = products[keys[i]];
      if (!pd || pd.sales_mode !== "ecommerce") continue;
      var variant = findVariant(keys[i], id);
      if (!variant) continue;
      return isInvalidPrice(variant.price);
    }
    return false;
  }

  function containsKnownInvalid(ids) {
    for (var i = 0; i < ids.length; i++) {
      if (variantKnownInvalid(ids[i])) return true;
    }
    return false;
  }

  function blockedResponse() {
    return new Response(JSON.stringify({
      status: 422,
      message: storeOnlyMessage(),
      description: "Cette configuration ne peut pas être ajoutée au panier en ligne.",
    }), {
      status: 422,
      statusText: "Unprocessable Entity",
      headers: { "Content-Type": "application/json" },
    });
  }

  function isCartAddRequest(input, init) {
    var url = (typeof input === "string" ? input : (input && input.url)) || "";
    var method = ((init && init.method) || (input && input.method) || "GET").toUpperCase();
    if (method !== "POST") return false;
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.origin !== window.location.origin) return false;
      var configured = ((window.MinimogSettings || {}).routes || {}).cart_add_url || "/cart/add";
      var cartPath = new URL(configured, window.location.href).pathname.replace(/\.js$/, "");
      return parsed.pathname === cartPath || parsed.pathname === cartPath + ".js";
    } catch (e) {
      return false;
    }
  }

  function inspectRequestBody(input) {
    try {
      var clone = input.clone();
      return clone.text().then(function (text) {
        return extractVariantIds(text);
      }).catch(function () {
        console.warn("[LFLPriceGuard] Corps Request illisible : ajout panier transmis sans blocage.");
        return null;
      });
    } catch (e) {
      console.warn("[LFLPriceGuard] Request impossible à cloner : ajout panier transmis sans blocage.");
      return Promise.resolve(null);
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || typeof form.getAttribute !== "function") return;
    var productId = form.getAttribute("data-product-id");
    if (!productId) return;
    var pd = productData(productId);
    if (!pd) return;
    if (pd.sales_mode !== "ecommerce") {
      event.preventDefault();
      event.stopPropagation();
      var storeMessage = form.querySelector(".m-product-form-message");
      if (storeMessage) {
        storeMessage.textContent = storeOnlyMessage();
        storeMessage.classList.add("m:block");
      }
      return;
    }
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var variant = findVariant(productId, idInput.value);
    if (variantIsPurchasable(variant)) return;

    event.preventDefault();
    event.stopPropagation();
    var message = form.querySelector(".m-product-form-message");
    if (message) {
      message.textContent = variantIsValid(variant)
        ? ((window.MinimogStrings || {}).soldOut || "Épuisé")
        : (strings().variantOnDemand || "Tarif sur demande pour cette dimension");
      message.classList.add("m:block");
    }
  }, true);

  function cartContainsBlocked(cart) {
    var blocked = blockedVariantIds();
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (blocked[String(items[i].variant_id)]) return true;
    }
    return false;
  }

  function removeBlockedCartItems() {
    if (window.location.pathname !== "/cart") return Promise.resolve(false);
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cartContainsBlocked(cart)) return false;
        var blocked = blockedVariantIds();
        var blockedItems = cart.items.filter(function (item) {
          return blocked[String(item.variant_id)];
        });
        return Promise.all(blockedItems.map(function (item) {
          return fetch("/cart/change.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        })).then(function () {
          var notice = document.createElement("p");
          notice.className = "m-cart__shipping-note";
          notice.setAttribute("role", "alert");
          notice.textContent = storeOnlyMessage();
          var main = document.querySelector("main") || document.body;
          main.insertBefore(notice, main.firstChild);
          return true;
        });
      })
      .catch(function () {
        console.warn("[LFLPriceGuard] Nettoyage du panier impossible.");
        return false;
      });
  }

  function initCartCleanup() {
    removeBlockedCartItems();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartCleanup);
  } else {
    initCartCleanup();
  }

  // Les cartes mettent à jour leur champ variante pendant l'événement change.
  // Le relais document s'exécute ensuite et reste limité à la carte concernée.
  document.addEventListener("change", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;
    var card = target.closest(".m-product-card[data-product-id]");
    if (!card) return;
    var productId = card.getAttribute("data-product-id");
    var idInput = card.querySelector('form[data-product-id="' + productId + '"] [name="id"]');
    if (!idInput) return;
    var variant = findVariant(productId, idInput.value);
    if (variant) applyProductVariantState(productId, variant, card);
  });

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input, init) {
      var fetchThis = this;
      var fetchArguments = arguments;
      if (!isCartAddRequest(input, init)) {
        return nativeFetch.apply(fetchThis, fetchArguments);
      }

      if (init && Object.prototype.hasOwnProperty.call(init, "body")) {
        if (containsKnownInvalid(extractVariantIds(init.body))) {
          return Promise.resolve(blockedResponse());
        }
        return nativeFetch.apply(fetchThis, fetchArguments);
      }

      if (typeof Request !== "undefined" && input instanceof Request) {
        return inspectRequestBody(input).then(function (ids) {
          if (ids && containsKnownInvalid(ids)) return blockedResponse();
          return nativeFetch.apply(fetchThis, fetchArguments);
        });
      }

      return nativeFetch.apply(fetchThis, fetchArguments);
    };
  }

  window.LFLPriceGuard = {
    variantIsValid: variantIsValid,
    findVariant: findVariant,
    applyProductVariantState: applyProductVariantState,
    blockedVariantIds: blockedVariantIds,
    cartContainsBlocked: cartContainsBlocked,
  };
})();
